import React, { useState } from 'react';
import "./OtherBentoGrid.css";
import { BentoGridModal, CardData } from '../BentoGridModal/BentoGridModal';
import { ChevronRight } from 'lucide-react';

const OTHER_CARDS: readonly CardData[] = [
    {
        title: 'One Platform. Built for Every Agency.',
        subtitle: 'Sales, Operations, and scheduling — one connected system, no matter your vertical.',
        buttonOne: 'See the Platform ›',
        buttonTwo: 'Book a demo',
        points: [
            'Operations, Sales, and scheduling in one connected system',
            'Industry-specific configurations out of the box',
            '1,500+ agencies across North America running on Worky',
            '$250M+ in payroll powered and growing',
        ],
        insideComponent: null,
    },
    {
        title: 'Run Leaner Operations.',
        subtitle: 'From open shift to approved timesheet — automated, with zero manual follow-up.',
        buttonOne: 'Explore Operations ›',
        buttonTwo: 'Book a demo',
        points: [
            'Bulk scheduling and worker auto-matching',
            'Real-time clock-in and payroll-ready timesheets',
            'Compliance and credential tracking built in',
            '40% reduction in coordinator workload on average',
        ],
        insideComponent: null,
    },
    {
        title: 'Payroll. Compliance. Reporting.',
        subtitle: 'Timesheets flow to payroll automatically — no manual exports, no missing hours.',
        buttonOne: 'See How It Works ›',
        buttonTwo: 'Book a demo',
        points: [
            'Auto-generated timesheets after every shift',
            'Direct payroll integration with no manual exports',
            'Compliance tracking and credential expiry alerts',
            'Full reporting by client, site, and worker',
        ],
        insideComponent: null,
    },
    {
        title: 'Close Deals Faster.',
        subtitle: 'Pipeline to proposal to signed contract — no spreadsheets, no dropped leads.',
        buttonOne: 'Explore Sales ›',
        buttonTwo: 'Book a demo',
        points: [
            'Pipeline and proposal management in one place',
            'Client billing and contract tracking',
            'Win/loss reporting and revenue forecasting',
            'Auto-renewal alerts for long-term accounts',
        ],
        insideComponent: null,
    },
    {
        title: 'Join 1,500+ Growing Agencies.',
        subtitle: "The fastest-growing agencies don't manage operations manually. They run on Worky.",
        buttonOne: 'Get Started ›',
        buttonTwo: 'Talk to sales',
        points: [
            '$250M+ in payroll powered across all verticals',
            '1,500+ agency owners trust Worky daily',
            'Average ROI realised in under 60 days',
            'Dedicated onboarding and support included',
        ],
        insideComponent: null,
    },
];

const OtherBentoGrid = (): React.ReactElement => {
    const [modalOpen, setModalOpen] = useState<boolean>(false);
    const [activeCard, setActiveCard] = useState<CardData>(OTHER_CARDS[0]);

    const handleOpenModal = (card: CardData): void => {
        setActiveCard(card);
        setModalOpen(true);
    };

    const handleClose = (): void => {
        setModalOpen(false);
    };

    return (
        <>
            <div className="other-grid">

                {/* Large hero card */}
                <div className="bento-card other-card-1">
                    <div className="bento-card-image-container"><img src='./bento-images/underground-billboard.png'/></div>
                    <div className="bento-card-text-container">
                        <div className="bento-card-text">
                            <div className="bento-card-title" >{OTHER_CARDS[0].title}</div>
                            <div className="bento-card-subtitle" >{OTHER_CARDS[0].subtitle}</div>
                        </div>
                        {/* <button className="bento-card-button"><ChevronRight size={20} /></button> */}
                    </div>
                </div>

                {/* Four equal-width medium cards */}
                <div className="other-grid-2">

                    <div className="bento-card other-card-2">
                        <div className="bento-card-image-container"><img src='./bento-images/runleaner.png'/></div>
                        <div className="bento-card-text-container">
                            <div className="bento-card-text">
                                <div className="bento-card-title">{OTHER_CARDS[1].title}</div>
                                <div className="bento-card-subtitle">{OTHER_CARDS[1].subtitle}</div>
                            </div>
                            {/* <button className="bento-card-button"><ChevronRight size={20} /></button> */}
                        </div>
                    </div>

                    <div className="bento-card other-card-2">
                        <div className="bento-card-image-container"><img src='./bento-images/workypayroll.jpg' style={{  marginRight:'-100px'}}/></div>
                        <div className="bento-card-text-container">
                            <div className="bento-card-text">
                                <div className="bento-card-title">{OTHER_CARDS[2].title}</div>
                                <div className="bento-card-subtitle">{OTHER_CARDS[2].subtitle}</div>
                            </div>
                            {/* <button className="bento-card-button"><ChevronRight size={20} /></button> */}
                        </div>
                    </div>

                    <div className="bento-card other-card-2">
                        <div className="bento-card-image-container"><img src='./bento-images/deals.jpg'/></div>
                        <div className="bento-card-text-container">
                            <div className="bento-card-text">
                                <div className="bento-card-title" >{OTHER_CARDS[3].title}</div>
                                <div className="bento-card-subtitle" >{OTHER_CARDS[3].subtitle}</div>
                            </div>
                            {/* <button className="bento-card-button"><ChevronRight size={20} /></button> */}
                        </div>
                    </div>

                    <div className="bento-card other-card-2">
                        <div className="bento-card-image-container"><img src='./bento-images/agencynetwork.png'/></div>
                        <div className="bento-card-text-container">
                            <div className="bento-card-text">
                                <div className="bento-card-title">{OTHER_CARDS[4].title}</div>
                                <div className="bento-card-subtitle">{OTHER_CARDS[4].subtitle}</div>
                            </div>
                            {/* <button className="bento-card-button"><ChevronRight size={20} /></button> */}
                        </div>
                    </div>

                </div>
            </div>

            <BentoGridModal open={modalOpen} onClose={handleClose} cardData={activeCard} />
        </>
    );
};

export { OtherBentoGrid };
